export interface PromiseHandler {
  resolve: (value: Response) => void;
  reject: (reason?: any) => void;
}
export const buildPromiseHandler = (
  resolve: (value: Response) => void,
  reject: (reason?: any) => void,
): PromiseHandler => {
  return { resolve, reject };
};
